import React from 'react';
import { Check, Star } from 'lucide-react';
import { SectionReveal, SectionHeading } from './Shared';
export const About = () => {
  const forWhom = ['Sentís interés por el crecimiento espiritual.', 'Querés aprender a leer Registros Akáshicos.', 'Buscás respuestas y comprensión personal.', 'Deseás desarrollar intuición y percepción.', 'Querés acompañar a otras personas.', 'Buscás una formación clara y estructurada.'];
  const benefits = ['Comprender patrones repetitivos.', 'Desarrollar mayor claridad interior.', 'Aprender a formular preguntas poderosas.', 'Interpretar símbolos y mensajes.', 'Realizar lecturas para vos y otras personas.', 'Desarrollar confianza profesional.', 'Integrar herramientas de acompañamiento.', 'Construir una práctica consciente.'];
  return <>
      {/* SECCIÓN 2: ¿QUÉ SON LOS REGISTROS AKÁSHICOS? */}
      <SectionReveal className="bg-celestial-800/30 border-y border-gold/10" data-id="element-11">
        <div className="container mx-auto px-6 max-w-4xl text-center" data-id="element-12">
          <div className="text-gold mb-4 font-medium tracking-widest uppercase text-sm" data-id="element-13">
            ¿Qué son los Registros Akáshicos?
          </div>
          <h2 className="text-3xl md:text-5xl font-serif text-gold-light mb-8 leading-tight" data-id="element-14">
            Conectá con una Fuente de Sabiduría y Comprensión Más Profunda
          </h2>
          <div className="space-y-6 text-lg md:text-xl text-indigo-100/80 font-light leading-relaxed" data-id="element-15">
            <p data-id="element-16">
              Los Registros Akáshicos son una herramienta de autoconocimiento
              que permite explorar aprendizajes, patrones, experiencias y
              comprensiones asociadas a nuestro camino de evolución.
            </p>
            <p data-id="element-17">
              Esta formación fue diseñada para ayudarte a desarrollar una
              conexión clara, consciente y estructurada con los Registros
              Akáshicos, aprendiendo a interpretar la información recibida de
              manera práctica y profesional.
            </p>
          </div>
        </div>
      </SectionReveal>

      {/* SECCIÓN 3: ¿PARA QUIÉN ES ESTA FORMACIÓN? */}
      <SectionReveal data-id="element-18">
        <div className="container mx-auto px-6 max-w-5xl" data-id="element-19">
          <div className="text-center mb-12" data-id="element-20">
            <h2 className="text-3xl md:text-4xl font-serif text-gold-light mb-4" data-id="element-21">
              ¿Para quién es esta formación?
            </h2>
            <div className="w-16 h-1 bg-gold mx-auto rounded-full" data-id="element-22" />
          </div>

          <div className="bg-celestial-800/50 backdrop-blur-md border border-gold/20 rounded-2xl p-8 md:p-12 shadow-xl relative overflow-hidden" data-id="element-23">
            <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-24"></div>

            <h3 className="text-2xl font-serif text-gold-light mb-8 text-center" data-id="element-25">
              Para vos si:
            </h3>

            <div className="grid md:grid-cols-2 gap-6 relative z-10" data-id="element-26">
              {forWhom.map((item, idx) => <div key={idx} className="flex items-start space-x-4 bg-celestial-900/40 p-4 rounded-xl border border-gold/10 hover:border-gold/30 transition-colors" data-id="element-27">
                  <div className="mt-1 bg-gold/10 p-1 rounded-full" data-id="element-28">
                    <Check className="w-5 h-5 text-gold" data-id="element-29" />
                  </div>
                  <span className="text-indigo-100/90" data-id="element-30">{item}</span>
                </div>)}
            </div>
          </div>
        </div>
      </SectionReveal>

      {/* SECCIÓN 4: LO QUE VAS A LOGRAR */}
      <SectionReveal className="bg-celestial-800/30" data-id="element-31">
        <div className="container mx-auto px-6 max-w-6xl" data-id="element-32">
          <SectionHeading title="Transformá Tu Forma de Comprender Tu Camino" subtitle="Lo que vas a lograr al finalizar este recorrido" data-id="element-33" />

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-34">
            {benefits.map((benefit, idx) => <div key={idx} className="bg-celestial-900/60 backdrop-blur-sm border border-gold/10 p-6 rounded-2xl hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(212,175,55,0.1)] hover:border-gold/30 transition-all duration-300 group text-center flex flex-col items-center" data-id="element-35">
                <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-36">
                  <Star className="w-6 h-6 text-gold fill-gold/20" data-id="element-37" />
                </div>
                <p className="text-indigo-100/90 font-medium" data-id="element-38">{benefit}</p>
              </div>)}
          </div>
        </div>
      </SectionReveal>
    </>;
};